document.addEventListener('keyup', function(e) {
  
  if (document.body.classList.contains('js-my-cart-open') && e.key === 'Escape') {
    document.body.classList.remove('js-my-cart-open');
  }
  if (e.key === 'c') {
    document.body.classList.add('js-my-cart-open');
  }
});

// Select the body and main elements
var body = document.body;
var mainElement = document.querySelector('.content');


// Create a mutation observer
var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    // Check if class attribute is modified
    if (mutation.attributeName === 'class') {
      // Check if the body has the 'js-my-cart-open' class
      if (body.classList.contains('js-my-cart-open')) {
        mainElement.addEventListener('click', function() {
          document.body.classList.remove('js-my-cart-open');
        });
      } else {
        mainElement.removeEventListener('click', function() {
          document.body.classList.remove('js-my-cart-open');
        });
      }
    }
  });
});

// Configure and start the mutation observer
var observerConfig = { attributes: true };
observer.observe(body, observerConfig);

// mobile menu 

document.addEventListener("DOMContentLoaded", function() {
  const menuButtons = document.querySelectorAll(".menu");
  const mobileElement = document.querySelector(".mobile");

  menuButtons.forEach(function(menuButton) {
    menuButton.addEventListener("click", function() {
      mobileElement.classList.toggle("open");
    });
  });
});